export enum VisitActivityEnum {
  MANUAL_TEXT_ENTRY = 'Manual text entry',
  TEXT_CREATION = 'Text creation',
  DATA_HUB = 'Data moving',
  INTERACTIVE_WORK = 'Interactive work',
  PEEKING_DATA = 'Peeking',
  BROWSING_INFO = 'Browsing',
}
